import { ContentWrapper } from '../../ui/content-wrapper/content-wrapper'
import { Footer } from '../../ui/footer/footer'
import { ClientPortalEoirInternalContent } from './ui/client-portal-eoir-internal-content/client-portal-eoir-internal-content'
import { ClientPortalEoirInternalHeader } from './ui/client-portal-eoir-internal-header/client-portal-eoir-internal-header'

export const ClientPortalEoirInternalPage = () => {
  return (
    <>
      <ContentWrapper>
        <ClientPortalEoirInternalHeader />
        <ClientPortalEoirInternalContent />
      </ContentWrapper>

      <Footer />
    </>
  )
}
